import { render, staticRenderFns } from "./campagin.vue?vue&type=template&id=a495bd44&scoped=true"
import script from "./campagin.vue?vue&type=script&lang=js"
export * from "./campagin.vue?vue&type=script&lang=js"
import style0 from "./campagin.vue?vue&type=style&index=0&id=a495bd44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a495bd44",
  null
  
)

export default component.exports